import { ModuleTemplate as BackendModuleTemplate } from "@longtail-education/superprep-data-model-frontend"
import { isSameContent } from "@nx-superprep/utils"

/**
 * Represents a module template with extended functionality for the frontend.
 */
export class ModuleTemplate extends BackendModuleTemplate {
  /** The unique identifier of the module template. */
  declare id: string

  /**
   * Checks if two ModuleTemplate objects are equal.
   * @param a The first ModuleTemplate object.
   * @param b The second ModuleTemplate object.
   * @returns A boolean indicating whether the two objects are equal.
   */
  static isEqual(a: ModuleTemplate | undefined, b: ModuleTemplate | undefined): boolean {
    return !!a && !!b && a.isEqual(b)
  }

  /**
   * Checks if the content of two arrays of ModuleTemplate objects is the same.
   * @param a The first array of ModuleTemplate objects.
   * @param b The second array of ModuleTemplate objects.
   * @returns A boolean indicating whether the content of the two arrays is the same.
   */
  static isSameContent(a: ModuleTemplate[] | undefined, b: ModuleTemplate[] | undefined): boolean {
    return !!a && !!b && isSameContent(a, b, 'id')
  }

  static validate(m: ModuleTemplate) {
    return m && !!m.id && !!m.title && !!m.description && m.cardCount > 0
  }

  isValid(): boolean {
    return ModuleTemplate.validate(this)
  }
}
